import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { AdminAuthGuard } from 'app/admin/admin-auth-guard.service';
import { FreshAppComponent } from './fresh-app.component';
import { ViewDisbursedComponent } from './view-disbursed/view-disbursed.component';
import { ViewEtbComponent } from './view-etb/view-etb.component';
import { ViewFailurePageComponent } from './view-failure-page/view-failure-page.component';
import { ViewIncompleteJourneyComponent } from './view-incomplete-journey/view-incomplete-journey.component';
import { ViewReportPageComponent } from './view-report-page/view-report-page.component';
import { ViewNtbComponent } from './view-ntb/view-ntb.component';
import { ViewSummaryComponent } from './view-summary/view-summary.component';
import { ReconciliationReportsComponent } from './reconciliation-reports/reconciliation-reports.component';
import { ErrorLogComponent } from './error-log/error-log.component';
import { ViewreviewJourneyComponent } from './view-review-journey/view-review-journey.component';
import { ValidationCardComponent } from './validation-card/validation-card.component';
import { StaleUsersReportComponent } from '../admin/stale-users-report/stale-users-report.component';

const routes: Routes = [{
  path: '', component: FreshAppComponent, children: [{ 
    path: 'view-disbursed', component: ViewDisbursedComponent ,canActivate:[AdminAuthGuard]},
    {path: 'view-failure-page', component: ViewFailurePageComponent ,canActivate:[AdminAuthGuard]},
    {path: 'view-incomplete-journey', component: ViewIncompleteJourneyComponent ,canActivate:[AdminAuthGuard]},
    {path: 'view-report-page', component: ViewReportPageComponent ,canActivate:[AdminAuthGuard]},
    {path: 'view-ntb', component: ViewNtbComponent ,canActivate:[AdminAuthGuard]},
    {path: 'view-summary', component: ViewSummaryComponent, canActivate:[AdminAuthGuard]},
    {path: 'view-etb', component: ViewEtbComponent, canActivate:[AdminAuthGuard]},
    {path:'view-review-journey' , component: ViewreviewJourneyComponent, canActivate:[AdminAuthGuard]},
     
    { path:'view-validation-customer',component:ValidationCardComponent,canActivate:[AdminAuthGuard] },     
    // { path: 'view-recon', component: ReconciliationReportsComponent,canActivate:[AdminAuthGuard] },
    { path: 'error-log', component: ErrorLogComponent,canActivate:[AdminAuthGuard] },
    { path: 'stale-users-report', component: StaleUsersReportComponent, canActivate:[AdminAuthGuard] },
  ]
}];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class FreshAppRoutingModule { }
